// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewPhoneAPIModel
 */
export interface NewPhoneAPIModel {
    /**
     * 
     * @type {string}
     * @memberof NewPhoneAPIModel
     */
    phone: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewPhoneAPIModel
     */
    skipConfirmation: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewPhoneAPIModel
     */
    sms?: string;
}

export function NewPhoneAPIModelFromJSON(json: any): NewPhoneAPIModel {
    return NewPhoneAPIModelFromJSONTyped(json, false);
}

export function NewPhoneAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewPhoneAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'skipConfirmation': json['skipConfirmation'],
        'sms': !exists(json, 'sms') ? undefined : json['sms'],
    };
}

export function NewPhoneAPIModelToJSON(value?: NewPhoneAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'skipConfirmation': value.skipConfirmation,
        'sms': value.sms,
    };
}


